<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-xm(:title="$t('mantra')")
    .grid.is-widescreen-8.is-desktop-10
      .column
        p.u-text-lg {{$t('mantraDesc')}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec1')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Product",
    "pageDesc":"We help you design and develop products with unique value propositions that serve humans everywhere around the globe.",
    "mantra":"Creating products| for humans.",
    "mantraDesc":"From the smallest gadgets to complex systems and devices, we think critically to come up with solutions not consumer products. And by cooperating with visionary partners, we integrate values into what we co-create to boost humanity with sustainable products and make people’s lives easier.",
    "sec1":"Before designs a product we ask few questions ..",
    "sec1Items":{
      "1":{
        "title":"Is it human centred?",
        "desc":"Since we are designing for how people would learn and interact, we need the final output to be accessible by our users and centred around their needs."
      },
      "2":{
        "title":"Does it meet a need?",
        "desc":"To make sure that we are not doing innovation of no value, we study your end users needs carefully and test the product with them before doing a final launch on the current specs."
      },
      "3":{
        "title":"Is it sustainable?",
        "desc":"Taking care of our environment is a highly considered issue while working on a new project. Since our product is meant to boost humanity not to take it backward."
      }
    },
    "sec2":"What we will be working on together?",
    "sec2Items":{
      "1":{
        "title":"Experience design",
        "desc":"We help you in engaging customers in a lovable experience that they will talk about to a friend. Eve if it’s just opening a drinking water bottle."
      },
      "2":{
        "title":"Technology integration",
        "desc":"Adding our tech touch to your product idea whenever possible to take into the digital era, optimize your operations or create a buzz."
      },
      "3":{
        "title":"Aesthetic and functionality balance",
        "desc":"Through research and prototyping, we make sure that aesthetics and functionality are both combined in your product."
      }
    },

    "cta":"Got an idea? <br> Let’s turn it into a product!"
  },
  "ar": {
    "pageTitle":"المنتج",
    "pageDesc":"نساعدك على تصميم وتطوير منتجات ذات قيمة فريدة تخدم الإنسان في كل مكان حول العالم وتحويل حياتهم نحو الأفضل.",
    "mantra":"نخلق منتجات لتلبية |احتياجات المستخدمين.",
    "mantraDesc":"بداية من الأدوات متناهية الصغر إلى الأنظمة والأجهزة المعقدة، نؤمن أن علينا التوصل إلى حلول جذرية وليس منتجات استهلاكية. من خلال التعاون مع شركاء النجاح أصحاب الرؤى، نعمل على دمج القيم من أجل تعزيز الإنسانية بالمنتجات المستدامة وجعل حياة الناس أفضل.",
    "sec1":"قبل تصميم أي منتج نطرح على أنفسنا بعض الأسئلة …",
    "sec1Items":{
      "1":{
        "title":"هل تتمحور حول الإنسان؟",
        "desc":"نظرًا لأننا نصمم حول كيفية تعلم الأشخاص وتفاعلهم، فإننا نحتاج إلى الوصول إلى المخرجات النهائية من قبل مستخدمينا والتركيز حول احتياجاتهم."
      },
      "2":{
        "title":"هل المنتجات تلبي حاجة محددة؟",
        "desc":"نتأكد أولاً بأننا لا نقع في خطأ 'الابتكار بلا قيمة'، فإننا ندرس احتياجات المستخدمين النهائيين بعناية ونختبر المنتج معهم قبل القيام بالتشغيل النهائي للمواصفات الحالية."
      },
      "3":{
        "title":"هل يتمتع بالاستدامة؟",
        "desc":"تعتبر العناية بالبيئة مشكلة يتم دراستها باهتمام أثناء العمل في أي مشروع جديد. حيث أن منتجنا يهدف إلى تعزيز الإنسانية وليس التسبب في انحدارها للوراء."
      }
    },
    "sec2":"ما الذي سنقدمه معًا؟",
    "sec2Items":{
      "1":{
        "title":"تجربة التصميم",
        "desc":"نساعدك في إشراك العملاء في تجربة محببة بالنسبة للمستخدمين تجعلهم يتحدثون عنها مع أصدقائهم، حتى إذا كانت حول كيفية فتح زجاجة مياه الشرب."
      },
      "2":{
        "title":"تكامل التكنولوجيا",
        "desc":"نعمل على إضافة لمسة تقنية إلى فكرة منتجك كلما أمكن من خلال الاستفادة من العصر الرقمي أو تحسين عملياتك."
      },
      "3":{
        "title":"التوازن الجمالي والوظيفي",
        "desc":"من خلال عملية البحث والنماذج الأولية، نتأكد أننا نعمل من أجل الجمع بين الجمال والوظائف في منتجك."
      }
    },
    "cta":"هل لديك فكرة؟! <br> دعنا نحولها إلى منتج!"
  }
}
</i18n>
